import { render } from "./FaIcon.vue?vue&type=template&id=66bef14c"
import script from "./FaIcon.vue?vue&type=script&lang=js"
export * from "./FaIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__